import React from 'react';
import { Space, Breadcrumb } from 'antd';
import { CardLayout, SEMINARTable } from 'components/molecules';
import SearchBox from './SearchBox'
import { useSeminar } from 'hooks';

export interface  SeminarProps {}

const  Seminar = ({}:  SeminarProps): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const { refetch, seminarList, searchResult } = useSeminar('ing');  
  const { refetch: closeRefetch, seminarList: closeList, searchResult: closeResult } = useSeminar('close');  

  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * events
   * ====================================================== */    
 
  /* ======================================================
   * hooks
   * ====================================================== */

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>B2C</Breadcrumb.Item>
        <Breadcrumb.Item>세미나</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
       <Space direction="vertical" style={{ width: '100%' }}>
          <SearchBox />
          <div style={{height:"20px"}}></div>
          <SEMINARTable
            title='모집중 과정'
            projectList={seminarList}
            searchResult={searchResult}
            hiddenColumns={[]}
            refetch={refetch}
            register={true}
            useExcelDownload={true}
          />  
          <div style={{height:"20px"}}></div>
          <SEMINARTable
            title='종료된 과정'
            projectList={closeList}
            searchResult={closeResult}
            hiddenColumns={[]}
            refetch={closeRefetch}
            register={false}
          />   
        </Space>               
    </CardLayout>
  )
};

export default  Seminar;    